import React, { useState } from "react";
import { Warning } from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";
import CommonModal from "../../ResetContext/components/DumpModal";
import { useAppServices } from "../../../../../hook/services";
import { useUserInfo } from "../../../../../context/user";
import toast from "react-hot-toast";

const texts = [
  {
    icon: <DoneIcon style={{ color: "#5f7eff", marginTop: "8px" }} />,
    text: "You keep all your existing work",
  },
  {
    icon: <Warning style={{ color: "#ed8f15", marginTop: "8px" }} />,
    text: "Fewer AI agents can run in parallel",
  },
  {
    icon: <Warning style={{ color: "#ed8f15", marginTop: "8px" }} />,
    text: "Limited team controls",
  },
];

const Downgrade = ({ isOpen, onClose, price_id, plan, paymentMethod_id }) => {
  const AppService = useAppServices();
  const [loading, setLoading] = useState(false);
  const userActiveLocation = useUserInfo()[4];
  const saveActiveLocation = useUserInfo()[5];

  const handleConfirmClick = async () => {
    setLoading(true);
    const { response: subscription, error } =
      await AppService.subscription.upgradeSubscription({
        payload: {
          agency_id: userActiveLocation?.agency_id,
          price_id,
          plan_id: plan?._id,
          account_id: userActiveLocation?._id,
          paymentMethod_id,
          customer_id: userActiveLocation?.customer_id,
          subscription_id: userActiveLocation?.subscription_id,
          subscription_type: "downgrade",
        },
      });
    if (subscription?.data) {
      saveActiveLocation(subscription.data);
      toast.success("Subscription updated successfully!");
    } else {
      toast.error(error?.message || "Failed to create subscription");
    }
    setLoading(false);
    onClose();
  };
  return (
    <CommonModal title="" showAlert={false} onClose={onClose} isOpen={isOpen}>
      <h4 className="text-xl font-semibold text-center mb-2">
        Proceed With Plan change?
      </h4>
      <p className="px-4 text-center text-[#464646] mb-4">
        {`You’re about to update your plan. No data will be lost, but some
        features will be turned off when your plan changes.`}
      </p>
      {texts.map((item, index) => (
        <div className="mx-4 flex gap-4 py-5 border-b items-center" key={index}>
          {item.icon}
          <p key={index} className="mt-2 text-lg font-medium">
            {item.text}
          </p>
        </div>
      ))}
      <div className="mt-8 flex flex-col ">
        <button
          onClick={() => {
            handleConfirmClick();
          }}
          disabled={loading}
          className="px-4 py-3 font-medium bg-black text-white rounded-md"
        >
          Yes, proceed with plan change
        </button>
        <button
          onClick={onClose}
          disabled={loading}
          className="px-4 font-medium py-3 mt-3 rounded-md border"
        >
          No, keep my existing plan
        </button>
      </div>
    </CommonModal>
  );
};

export default Downgrade;
